module.exports = __webpack_public_path__ + "static/media/iotnet1.784ace38.jpeg";